<div class="loader-licenses" *ngIf="licensesLoading">
  <app-loader></app-loader>
</div>

<div *ngIf="licensesData.length === 0 && !licensesLoading">
  <h1 class="u-mb30 txt txt--title"> Licencias </h1>
  <p *ngIf="infractionsError !== '' "> {{licensesError }} </p>
  <p *ngIf="infractionsError === '' ">No hay licencias registradas.</p>
  <a *ngIf="infractionsError === '' " type="button" class="btn btn--primary" routerLink="/license/new">Crear
    una nueva solicitud de
    licencia</a>
</div>

<swiper *ngIf=" !licensesLoading" class="license-swiper" [slidesPerView]="1" [spaceBetween]="50"
  [pagination]="{ clickable: true }" [controller]="{ control: controlledSwiper }">
  (swiper)="setControlledSwiper($event)"
  (slideChange)="onSlideChange()">

  <ng-template swiperSlide *ngFor="let license of licensesData;index as i;" class="swiper-content">

    <app-license-card *ngIf="!licensesLoading" [licensesData]="license" [licenseIndex]="i"
      [zonesRows]="zonesRows" [usingAspect]="'MY_PROFILE'" [licensesLength]="licensesData.length">
    </app-license-card>

    <div class="innermenu">
      <ul style="text-align: center;">
        <li class="mobile-options to-left">
          <a (click)="onClickDocumentsValidity(i)" class="toggle global-hand" data-id="tab-one-b">Ver
            vigencia <br> de
            documentos</a>
        </li>
        <li class="mobile-options">
          <a [routerLink]="['/license/renew']" routerLinkActive="router-link-active">Renovar <br>
            licencia</a>
        </li>
        <li class="mobile-options to-right">
          <a [routerLink]="['/license/extend']" routerLinkActive="router-link-active">Ampliar <br>
            licencia</a>
        </li>
      </ul>
    </div>

  </ng-template>
</swiper>

<div *ngIf="licensesData.length > 0 && !showDocumentsValidity" class="togglegroup" id="tab-one-c">

  <div *ngFor="let license of licensesData; index as i;" class="license-card-container">
    <div class="innermenu" [ngClass]="{' u-bt u-bt--grey u-pt30 u-mt50': i > 0}">
      <ul>
        <li>
          <a (click)="onClickDocumentsValidity(i)" class="toggle global-hand" data-id="tab-one-b">Ver
            vigencia de
            documentos</a>
        </li>
        <li>
          <a [routerLink]="['/license/renew']" routerLinkActive="router-link-active">Renovar
            licencia</a>
        </li>
        <li>
          <a [routerLink]="['/license/extend']" routerLinkActive="router-link-active">Ampliar
            licencia</a>
        </li>
      </ul>
    </div>

    <app-license-card [licensesData]="license" [licenseIndex]="i" [zonesRows]="zonesRows"
      [usingAspect]="'MY_PROFILE'"></app-license-card>
  </div>
</div>

<div *ngIf="showDocumentsValidity">
  <app-documents-validity [licenseData]="licenseDetail" (returnToLicenses)="showDocumentsValidity = $event">
  </app-documents-validity>
</div>
